import { getIPay, downloadIPayCsv } from '../services/napi';
import { IPAY_FETCH_SUCCESS, DOWNLOAD_IPAY_SUCCESS } from '../constant/actionType';

export function fetchIPay() {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await getIPay(projectId);
      dispatch({
        data: response.data.transactions,
        type: IPAY_FETCH_SUCCESS
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function downloadIPay() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await downloadIPayCsv(projectId);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `textIPay.csv`);
    document.body.appendChild(link);
    link.click();

    dispatch({
      data: response.data,
      type: DOWNLOAD_IPAY_SUCCESS
    });
  };
}
